module.exports = __webpack_public_path__ + "static/media/twitter.7137286d.svg";